import React from 'react'
import { Link } from 'react-router-dom'
import { Tooltip, Typography } from 'antd'
import { includes, isNil, map } from 'lodash'

import { formatDateFromNow } from '../../core/utils'

import MenuCurationTaskDeleteButton from '../components/sections/menu-curation-task-delete-button'
import MenuCurationTaskTableAssignation from '../components/sections/menu-curation-task-table-assignation'
import StyledMenuAvailabiltyLabel from '../components/styled/style-menu-availabilty-label'
import StyledMenuCurationTaskTag from '../components/styled/styled-menu-curation-task-tag'
import {
  CURATION_DETAIL_LEVEL,
  MENU_CURATION_TASK_SORT_BY,
  MENU_CURATION_TASK_STATUS,
  MENU_CURATION_TASK_TAGS,
} from '../constants'

const createMenuCurationTaskTableColumns = (
  isDeleteButtonVisible,
  sortBy,
  isAssignmentHidden,
) => [
  {
    title: 'ID',
    render: ({ id }) => (
      <Link target="_blank" to={`/menu-curation-tasks/${id}`}>
        {id}
      </Link>
    ),
  },
  {
    title: 'Brand',
    render: ({ id, menu }) => (
      <Link target="_blank" to={`/menu-curation-tasks/${id}`}>
        {menu?.brand?.name}
      </Link>
    ),
  },
  ...(!isAssignmentHidden
    ? [
        {
          title: 'Assigned',
          render: menuCurationTask => (
            <MenuCurationTaskTableAssignation
              menuCurationTask={menuCurationTask}
            />
          ),
        },
      ]
    : []),
  {
    title: 'Curation Level',
    render: ({ curationDetailLevel }) => (
      <Typography.Paragraph>
        {CURATION_DETAIL_LEVEL[curationDetailLevel]?.label}
      </Typography.Paragraph>
    ),
  },
  {
    title: 'Availability',
    width: 100,
    render: ({
      isAvailableForTierOne,
      isAvailableForUnknownWordsCuration,
      isAvailableForUnknownWordsQa,
      isAvailableForCuration,
      isAvailableForQa,
      isAvailableForQc,
    }) => (
      <>
        {isAvailableForTierOne && (
          <StyledMenuAvailabiltyLabel>Tier 1</StyledMenuAvailabiltyLabel>
        )}
        {isAvailableForUnknownWordsCuration && (
          <StyledMenuAvailabiltyLabel>UW Curation</StyledMenuAvailabiltyLabel>
        )}
        {isAvailableForUnknownWordsQa && (
          <StyledMenuAvailabiltyLabel>UW QA</StyledMenuAvailabiltyLabel>
        )}
        {isAvailableForCuration && (
          <StyledMenuAvailabiltyLabel>Curation</StyledMenuAvailabiltyLabel>
        )}
        {isAvailableForQa && (
          <StyledMenuAvailabiltyLabel>QA</StyledMenuAvailabiltyLabel>
        )}
        {isAvailableForQc && (
          <StyledMenuAvailabiltyLabel>QC</StyledMenuAvailabiltyLabel>
        )}
      </>
    ),
  },
  {
    title: 'Status',
    render: ({ taskStatus }) => MENU_CURATION_TASK_STATUS[taskStatus]?.label,
  },
  {
    title: 'Tags',
    width: 100,
    render: ({ tags }) =>
      map(tags, tag => (
        <StyledMenuCurationTaskTag
          key={tag}
          isError={includes(
            [
              MENU_CURATION_TASK_TAGS.HAS_TIMEOUT_ERROR.value,
              MENU_CURATION_TASK_TAGS.HAS_UNCAUGHT_AI_ERROR.value,
              MENU_CURATION_TASK_TAGS.HAS_UNCAUGHT_MENU_CURATOR_ERROR.value,
            ],
            tag,
          )}
          isWarning={includes(
            [
              MENU_CURATION_TASK_TAGS.IS_OVERDUE.value,
              MENU_CURATION_TASK_TAGS.HAS_METADATA_ERROR.value,
            ],
            tag,
          )}
        >
          {MENU_CURATION_TASK_TAGS[tag].label}
        </StyledMenuCurationTaskTag>
      )),
  },
  {
    title: 'Cuisine Type',
    render: ({ menu }) => (
      <Typography.Text>{menu?.brand?.cuisineType?.name}</Typography.Text>
    ),
  },
  {
    title: 'Dishes',
    render: ({ menu: { dishCount } }) => dishCount,
  },
  {
    title: 'U.W.',
    render: ({
      curatedUnknownWordCount,
      qadUnknownWordCount,
      totalUnknownWordCount,
    }) => (
      <>
        <Tooltip title="Curated words">
          <Typography.Paragraph>
            {curatedUnknownWordCount} / {totalUnknownWordCount}
          </Typography.Paragraph>
        </Tooltip>
        <Tooltip title="Qad words">
          <Typography.Paragraph>
            {qadUnknownWordCount} / {totalUnknownWordCount}
          </Typography.Paragraph>
        </Tooltip>
      </>
    ),
  },
  ...(sortBy === MENU_CURATION_TASK_SORT_BY.DEFAULT.value
    ? [
        {
          title: 'Updated',
          dataIndex: 'lastManualUpdateAt',
          render: date => date && formatDateFromNow(date),
        },
      ]
    : []),
  ...(sortBy === MENU_CURATION_TASK_SORT_BY.QA.value
    ? [
        {
          title: 'Curated',
          dataIndex: 'curatedAt',
          render: date => date && formatDateFromNow(date),
        },
      ]
    : []),
  ...(sortBy === MENU_CURATION_TASK_SORT_BY.QC.value
    ? [
        {
          title: `Qa'd`,
          dataIndex: 'qadAt',
          render: date => date && formatDateFromNow(date),
        },
      ]
    : []),
  {
    title: 'Autoeat Updated',
    dataIndex: 'menu',
    render: menu => {
      const autoeatUpdateDate = !isNil(menu.autoeatUpdateAppliedAt)
        ? menu.autoeatUpdateAppliedAt
        : menu.autoeatUpdatedAt

      if (!isNil(autoeatUpdateDate)) {
        return formatDateFromNow(autoeatUpdateDate)
      }

      return null
    },
  },
  {
    title: 'Added',
    dataIndex: 'createdAt',
    render: date => date && formatDateFromNow(date),
  },
  ...(!isDeleteButtonVisible
    ? []
    : [
        {
          title: 'Actions',
          render: ({ menu }) => {
            if (!menu.isFake) {
              return null
            }

            return <MenuCurationTaskDeleteButton menuId={menu.id} />
          },
        },
      ]),
]

export default createMenuCurationTaskTableColumns
